export enum ButtonType {
  Filled = 'filled',
  Outlined = 'outlined',
  Danger = 'danger',
  Text = 'text',
  Icon = 'icon',
  Plain = 'plain',
  BrandYellow = 'brand-yellow',
}
